import type { SVGProps } from "react";

export type AppIconName = "brand" | "search" | "calculator" | "database" | "check" | "warning";

type AppIconProps = {
  name: AppIconName;
  size?: number;
};

const common: SVGProps<SVGSVGElement> = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  focusable: "false",
  "aria-hidden": true,
};

export function AppIcon({ name, size = 18 }: AppIconProps) {
  const props = { ...common, width: size, height: size };
  if (name === "search") return <svg {...props}><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></svg>;
  if (name === "calculator") return <svg {...props}><rect x="5" y="3" width="14" height="18" rx="3" /><path d="M8 7h8M8 11h2M14 11h2M8 15h2M14 15h2M8 18h8" /></svg>;
  if (name === "database") return <svg {...props}><ellipse cx="12" cy="5" rx="7" ry="3" /><path d="M5 5v7c0 1.7 3.1 3 7 3s7-1.3 7-3V5M5 12v7c0 1.7 3.1 3 7 3s7-1.3 7-3v-7" /></svg>;
  if (name === "check") return <svg {...props}><path d="m5 12 4 4L19 6" /></svg>;
  if (name === "warning") return <svg {...props}><path d="m12 4 9 16H3L12 4Z" /><path d="M12 9v5M12 17h.01" /></svg>;
  return <svg {...props}><path d="M12 3 4 7v5c0 5 3.4 8 8 9 4.6-1 8-4 8-9V7l-8-4Z" /><path d="m8.5 12 2.2 2.2 4.8-5" /></svg>;
}
